import { useState } from "react";
import toast from "react-hot-toast";
import { useSubmitContactMessageMutation } from "../../app/features/contact/contactApi";
const europeanCountries = [
  "Austria",
  "Belgium",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
];

const EuropeMap = () => (
  <svg
    viewBox="0 0 500 380"
    className="w-full h-full"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M240 20 L255 15 L270 25 L275 50 L265 80 L255 100 L245 90 L235 70 L230 45 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M275 30 L295 20 L310 35 L305 60 L290 75 L278 65 L272 45 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M310 20 L330 15 L345 30 L340 60 L325 75 L310 65 L305 45 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M170 60 L185 55 L195 70 L190 90 L178 95 L168 82 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M165 100 L175 95 L180 110 L172 118 L163 112 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M185 115 L215 108 L230 120 L228 148 L210 160 L192 155 L180 140 Z"
      fill="#9b59b6"
      opacity="0.65"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M165 160 L205 155 L220 165 L218 190 L195 205 L168 200 L155 185 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M148 165 L163 162 L162 195 L148 198 L140 182 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M215 100 L245 95 L258 108 L255 135 L240 142 L220 138 L210 122 Z"
      fill="#9b59b6"
      opacity="0.65"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M220 142 L255 138 L268 148 L265 162 L242 168 L220 162 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M222 168 L242 165 L252 178 L250 210 L238 230 L228 225 L218 205 L215 185 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M258 90 L295 85 L308 98 L305 120 L275 128 L255 118 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M258 122 L300 118 L312 128 L308 142 L268 148 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M268 148 L308 142 L318 152 L312 165 L272 168 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M312 128 L350 125 L362 140 L355 168 L318 165 L308 148 Z"
      fill="#9b59b6"
      opacity="0.6"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M268 168 L315 165 L325 178 L318 200 L298 210 L272 205 L260 190 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M295 210 L318 205 L325 220 L315 240 L298 242 L285 228 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M295 58 L315 55 L325 65 L320 80 L305 82 L292 72 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M292 80 L310 78 L318 88 L308 98 L290 95 Z"
      fill="#9b59b6"
      opacity="0.5"
      stroke="#c084fc"
      strokeWidth="1"
    />
    <path
      d="M242 58 L255 55 L260 65 L255 75 L243 72 Z"
      fill="#9b59b6"
      opacity="0.55"
      stroke="#c084fc"
      strokeWidth="1"
    />
  </svg>
);

// Inline SVG Icons replacing react-icons
const SendIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.42 2 2 0 0 1 3.6 1.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.83a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export default function Contact() {
  const [submitContactMessage, { isLoading }] = useSubmitContactMessageMutation();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    country: "",
    program: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContactMessage({
        full_name: formData.fullName,
        email: formData.email,
        country: formData.country,
        program: formData.program,
        message: formData.message,
      }).unwrap();
      toast.success("Message sent! Thank you, we'll get back to you soon.");
      setSubmitted(true);
      setFormData({ fullName: "", email: "", country: "", program: "", message: "" });
      setTimeout(() => setSubmitted(false), 4000);
    } catch {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 font-sans">
      <div className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* LEFT — Contact Form */}
        <div className="bg-purple-50 rounded-3xl p-8 shadow-sm">
          <h1 className="text-3xl font-extrabold text-purple-700 mb-1">
            Contact & Application
          </h1>
          <p className="text-gray-500 text-sm mb-7 leading-relaxed">
            Start your journey to study in Europe with our expert guidance.
            <br />
            Fill out the form below to get started.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Name + Email */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="John Doe"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent transition"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent transition"
                />
              </div>
            </div>

            {/* Country */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                Preferred Study Destination
              </label>
              <div className="relative">
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  className="w-full appearance-none bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent transition cursor-pointer pr-10"
                >
                  <option value="" disabled>
                    Select a country
                  </option>
                  {europeanCountries.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                  <ChevronDownIcon />
                </div>
              </div>
              <div className="flex justify-end mt-1">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 inline-block" />
              </div>
            </div>

            {/* Program */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                Program of Interest
              </label>
              <input
                type="text"
                name="program"
                placeholder="e.g. Masters in Data Science"
                value={formData.program}
                onChange={handleChange}
                className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent transition"
              />
            </div>

            {/* Message */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                Message or Questions
              </label>
              <textarea
                name="message"
                rows={4}
                placeholder="Tell us more about your academic goals..."
                value={formData.message}
                onChange={handleChange}
                className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent transition resize-none"
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex items-center justify-center gap-2.5 bg-gradient-to-r from-purple-600 to-violet-500 hover:from-purple-700 hover:to-violet-600 text-white font-semibold text-sm py-3.5 rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <SendIcon />
              {isLoading ? "Sending..." : submitted ? "✓ Application Sent!" : "Submit Application"}
            </button>
          </form>
        </div>

        {/* RIGHT — Get in Touch */}
        <div className="flex flex-col justify-between gap-6">
          <div>
            <h2 className="text-2xl font-bold text-purple-600 mb-2">
              Get in Touch
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed max-w-sm">
              Our consultants are available Monday through Friday to answer your
              questions about universities, visa requirements, and living in
              Europe.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
                <LocationIcon />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-sm">
                  Bangladesh Office
                </p>
                <p className="text-gray-500 text-sm">
                  SA Paribahan Goli House-32 (5th floor) road-02, Mirpur 10,
                  Block-Kha, Dhaka
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
                <LocationIcon />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-sm">
                  Headoffice Office
                </p>
                <p className="text-gray-500 text-sm">Helsinki, Finland</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
                <MailIcon />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-sm">Email Us</p>
                <p className="text-gray-500 text-sm">didar@uniedu.fi</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
                <PhoneIcon />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-sm">Call Us</p>
                <p className="text-gray-500 text-sm">+358 44 2762209</p>
              </div>
            </div>
          </div>

          {/* Map Card */}
          <div className="relative rounded-2xl overflow-hidden bg-purple-100 h-52 flex items-end shadow-sm">
            <div className="absolute inset-0 opacity-80">
              <EuropeMap />
            </div>
            <div className="relative z-10 m-4 bg-white rounded-xl px-4 py-2.5 shadow-sm">
              <p className="text-xs font-semibold text-purple-500 uppercase tracking-widest mb-0.5">
                Our Coverage
              </p>
              <p className="text-base font-bold text-gray-800">
                25+ European Countries
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
